const ALLOWED_TAGS = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'strong', 'label'];

export function getHeadingStylingSettings(field) {
    const defaults = {
        title_color: '',
        title_class: '',
        subtitle_type: 'p',
        subtitle_color: '',
        subtitle_class: '',
    };
    const raw = field?.heading_styling_settings || {};

    return { ...defaults, ...raw };
}

function sanitizeTag(tag, fallback = 'p') {
    const normalized = String(tag || '').toLowerCase().trim();
    return ALLOWED_TAGS.includes(normalized) ? normalized : fallback;
}

function resolveTitleTag(field) {
    const fieldType = field?.field_type || '';
    let titleType = field?.heading_type || '';

    if (fieldType === 'label' && (!titleType || titleType === 'label')) {
        return null;
    }

    if (!titleType) {
        if (fieldType === 'heading') {
            titleType = 'h2';
        } else {
            titleType = 'p';
        }
    }

    return sanitizeTag(titleType, 'p');
}

function buildStyle(color) {
    return color ? { color } : undefined;
}

/**
 * Layout/spacing for title and subtitle tags inside block checkout.
 * Overrides WC `.wc-block-components-text-input label` absolute positioning when subtitle uses `label`.
 */
function buildHeadingTagLayoutStyle(fieldType, role, hasSubtitle) {
    const isHeading = fieldType === 'heading';
    const resetWcLabelStyles = {
        position: 'static',
        transform: 'none',
        top: 'auto',
        left: 'auto',
        right: 'auto',
        maxWidth: 'none',
        overflow: 'visible',
        textOverflow: 'clip',
        cursor: 'default',
    };

    const baseBlock = {
        display: 'block',
        whiteSpace: 'normal',
        marginLeft: 0,
        marginRight: 0,
        ...resetWcLabelStyles,
    };

    if (role === 'title') {
        return {
            ...baseBlock,
            lineHeight: isHeading ? 1.3 : 1.45,
            marginTop: 0,
            marginBottom: hasSubtitle ? (isHeading ? '12px' : '8px') : 0,
        };
    }

    return {
        ...baseBlock,
        lineHeight: 1.5,
        marginTop: isHeading ? '4px' : '2px',
        marginBottom: 0,
    };
}

function mergeStyles(...styles) {
    return Object.assign({}, ...styles.filter(Boolean));
}

export function renderHeadingStylingField(field, isError = false) {
    const settings = getHeadingStylingSettings(field);
    const title = field?.field_label || '';
    const subtitle = field?.field_placeholder || '';
    const fieldName = field?.field_name || '';
    const fieldType = field?.field_type || '';
    const titleTag = resolveTitleTag(field);
    const subtitleTag = sanitizeTag(settings.subtitle_type, 'p');
    const hasSubtitle = Boolean(subtitle);
    const wrapperClass = fieldType === 'label'
        ? 'ccfw-label-block'
        : 'ccfw-heading-block';

    const titleProps = {
        id: fieldName,
        className: [settings.title_class, isError ? 'has-error' : ''].filter(Boolean).join(' ') || undefined,
        style: mergeStyles(
            buildHeadingTagLayoutStyle(fieldType, 'title', hasSubtitle),
            buildStyle(settings.title_color)
        ),
    };

    const subtitleProps = {
        className: settings.subtitle_class || undefined,
        style: mergeStyles(
            buildHeadingTagLayoutStyle(fieldType, 'subtitle', hasSubtitle),
            buildStyle(settings.subtitle_color)
        ),
    };

    return {
        wrapperClass,
        fieldType,
        title,
        subtitle,
        titleTag,
        subtitleTag,
        titleProps,
        subtitleProps,
    };
}
